import React, { FC } from 'react';
import { Col, FormGroup, FormLabel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import ColorInput from '../../../../../../components/library/inputs/color/ColorInput';

interface Props {
  label: string;
  size: number;
  value: string | undefined;
  onChange: (event: string | undefined) => void;
}

const ColorSetting: FC<Props> = ({ label, size = 12, value, onChange }: Props) => {
  return (
    <FormGroup className={'form-group'} as={Col} size={size}>
      <FormLabel>
        <FormattedMessage id={label} />
      </FormLabel>
      <ColorInput value={value} onChange={onChange} />
    </FormGroup>
  );
};

export default ColorSetting;
